export default abstract class Positioning {
  abstract getPosition();
}
